<template>
    <div class="home">
        <h1 class="hidden-page-title">Welcome to the Dunlop Tyres website - the home of one of the most iconic and recognisable tyre brands in the world.</h1>

        <Banner />

        <div class="container">
            <div id="HomeMainLinks" class="mt-3 mb-3 mt-lg-4 mb-lg-5">
                <HomeMainLinks />
            </div>

            <div id="HomeRange" class="my-4 my-lg-5">
                <div class="home-view-all">
                    <a target="_top" href="/tyre-range" class="btn chevron-right-icon">Explore the Dunlop range</a>
                </div>

                <Range />
            </div>

            <div id="HomeManufacturer" class="my-4 my-lg-5">
                <div class="home-view-all">
                    <a target="_top" href="https://vehicles.dunloptyres.co.za/" class="btn chevron-right-icon">Leading manufacturers fit Dunlop</a>
                </div>

                <Manufacturer />
            </div>
        </div>

        <div id="SPVanBanner">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-12 col-lg-12">
                        <div class="sp-van-copy text-white">
                            <h4 class="text-uppercase">Introducing the SP SPORT<br />MAXX 060+</h4>
                            <p><i>The finest in Japanese ultra-high performance, offering excellent dry & wet performance.</i></p>
                            <a target="_top" href="/Tyre-Range/Passenger/SP%20SPORT%20MAXX%20060+?site=dunlop" class="btn btn-yellow mt-3 mt-lg-5 px-4 px-sm-5 text-uppercase rounded-0">Explore</a>
                        </div>
                    </div>
                </div>
            </div>

            <span class="background-darken-overlay"></span>

        </div>

        <div class="container">

            <div id="HomeNews" class="my-4 my-lg-5">
                <div class="home-view-all">
                    <a target="_top" href="/About-Dunlop/Latest-News" class="btn chevron-right-icon">News &amp; Events</a>
                </div>

                <div class="article-collection">
                    <News />
                </div>
            </div>

            <div id="HomeKnowYourTyres" class="my-4 my-lg-5">
                <div class="home-view-all">
                    <a target="_top" href="/know-your-tyres" class="btn chevron-right-icon">Know your tyres</a>
                </div>

                <div class="article-collection">
                    <KnowYourTyres />
                </div>
            </div>


        </div>
        <div class="modal fade" id="tyrediagram" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <small style="vertical-align: middle; ">close</small> <span style="vertical-align: middle;" aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <img src="/Content/UserContent/images/tyres-diagram.jpg" class="img-fluid d-none d-md-block type-diagram">
                        <img src="/Content/UserContent/images/tyres-diagram-mobile.jpg" class="img-fluid d-block d-md-none type-diagram" style="margin: auto">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from './block/home/Banner.vue';
    import HomeMainLinks from './block/home/HomeMainLinks.vue';
    import Range from './block/home/Range.vue';
    import Manufacturer from './block/home/Manufacturer.vue';
    import KnowYourTyres from './block/home/KnowYourTyres.vue';
    import News from './block/home/News.vue';

    import 'swiper/swiper-bundle.min.css'

    export default {
        components: {
            Banner,
            HomeMainLinks,
            Range,
            Manufacturer,
            KnowYourTyres,
            News,
        }
    };
</script>
